import Breadcrumb from "../components/Breadcrumb";
import CarListingBookedLayer from "../components/child/CarListingBookedLayer"

const CarListingBooked = () => {
  return (
    <>
        {/* Breadcrumb */}
        <Breadcrumb title='Booked Cars' />

        <CarListingBookedLayer />
    </>
  );
};

export default CarListingBooked;

